import {Component, Input, OnInit} from '@angular/core';
import * as pbi from 'powerbi-client';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.css']
})
export class PageComponent implements OnInit {

  @Input()
  token: any | undefined;

  @Input()
  powerbi: pbi.service.Service | undefined

  constructor() { }

  ngOnInit(): void {
    // @ts-ignore
    let reportsContainer = document.getElementById(this.token.index) as HTMLElement;

    console.warn('[pbi-embed] embed()', {
      index: this.token?.index,
      name: this.token?.name,
      tokenType: this.token?.tokenType,
      embedUrl: this.token?.embedUrl,
      containerFound: !!reportsContainer,
      accessTokenLength: this.token?.accessToken?.length ?? 0
    });

    // @ts-ignore
    const report = this.powerbi.embed(
      reportsContainer,
      this.token
    );

    const iframe = reportsContainer?.querySelector('iframe');
    console.warn('[pbi-embed] iframe created', {
      index: this.token?.index,
      src: iframe?.src
    });

    // Removes a given event handler if it exists.
    report.off('loaded');

    // Add an event handler which prints to Log window.
    report.on('loaded', () => {
      console.warn('[pbi-embed] loaded', {
        index: this.token?.index,
        name: this.token?.name,
        iframeSrc: reportsContainer?.querySelector('iframe')?.src
      });
    });

    report.off('pageChanged');
    report.on('pageChanged', event => {
      console.warn('[pbi-embed] pageChanged', event?.detail);
    });

    report.off('error');
    report.on('error', event => {
      console.error('[pbi-embed] iframe error', {
        index: this.token?.index,
        name: this.token?.name,
        iframeSrc: reportsContainer?.querySelector('iframe')?.src,
        detail: event?.detail
      });
    });
  }

}
